﻿import { ISearchResult } from './ISearchResult';
import ResultView from './ResultView';

/**
 * Bal oldali kereső: listás találi réteg
 */
export default class ListView {
    private _insertBeforeElement: HTMLElement;

    constructor() {        
        this._insertBeforeElement = $("#search-more-button").closest(".row")[0];
    }

    loadResults(searchResult: any, continueSearch: boolean) {

        if (!continueSearch)
            $(".search__result-list").remove(); // töröljük az előző eredményeket a listából

        $(searchResult.html).insertBefore(this._insertBeforeElement);        

        (window as any).initProvinceSlick();
    }
}
